import { CSSProperties, useContext, useMemo } from "react";
import DashboardPageContext from "../DashboardPageContext";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import ReactJson from "react-json-view";
import { ComponentProps } from "../types";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context } = useContext(DashboardPageContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		style.fontFamily = "courier new";
		style.fontSize = "13px";
		return style;
	}, [component, exeMode]);

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context]);

	const value = useMemo(() => {
		const data = evaluteScript(component.properties["object"], false);
		if (data === undefined) return {};
		return data;
	}, [component, context]);

	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);

	return (
		<>
			<span {...args} style={style} {...locatorArgs}>
				{value && <ReactJson src={value} />}
			</span>
		</>
	);
}

export default Component;
